import { Component, OnInit, Renderer2, ElementRef, TemplateRef, ViewChild} from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { CommonFunctionsService,UserService, SeoService, ValidationService, NgxToasterService} from '../../../../_services/index';
import { ActivatedRoute,Router,NavigationEnd  } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import {  TextSetting } from '../../../../textsetting';
import { Subject, interval } from 'rxjs';
import { FooterService } from '../../service/index';
import { CommonService }  from '../../service/index';
import { ScriptService } from '../../../../_services/script.service';
import { PopupComponent } from '../elements/popup.component';
 declare var $:any;

@Component({ 
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css'],
	providers: [CommonFunctionsService,UserService, SeoService, FooterService, CommonService, ScriptService],
})
export class HeaderComponent implements OnInit{

	/**This is used to prevent memory leaks **/
	private ngUnsubscribe: Subject<void> = new Subject<void>();
	/**This is used to prevent memory leaks **/

	env	=	environment;
	urlLang: any = '';
	scrolled: boolean = false;
	openNav: boolean = false;
	counter:number=0;
	TextSetting          = TextSetting;
	notificationData	: any		= [];
	current_page    	: number  	=  1;
	total_record    	: number  	=  0;
	limit           	: number  	= 3;
	userData			: any		= {};
	isNotificationLoading : any = false;
	result : boolean = false;
	menuClass : boolean = false;

	// Declare Constructor
	constructor(
		public translate: TranslateService,
		public commonFunctionsService: CommonFunctionsService,
		public userService: UserService,
		private route: ActivatedRoute,
		public footerService : FooterService,
		private renderer: Renderer2,
		private seo : SeoService, 
		public router: Router,
		public scriptService: ScriptService,
		public commonService:CommonService
	) {
		this.route.queryParams.subscribe(params => {
			const paramsSub: any = params;
			if (typeof (paramsSub.lang) !== 'undefined' && paramsSub.lang !== '' && this.env.LANGUAGES_ARRAY.indexOf(paramsSub.lang) != -1) {
				this.urlLang = paramsSub.lang;
			}
			this.setLanguage();
		})

		/**this is used to update current user */
		router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				if ( this.userService.getCurrentUser() && Object.keys(this.userService.getCurrentUser()).length !== 0 ) {
					this.userService.updateCurrentUserData();
				}
			}
		});
		/**this is used to update current user */
 
	}

	ngOnInit(): void {		
		/**this is used to get notification counter */
		this.commonFunctionsService.isBrowser.subscribe((isBrowser) => {
			if(isBrowser){
				let that = this;
				setInterval(() => { 
					that.getCounter();
				}, 10000);
			}
		});
		/**this is used to get notification counter */
	}


	/**this function is used to set meta tags from text settings*/
	public getMetaTags(){
		this.footerService.getFooterSetting().subscribe((response: any) => {
			if (response.status === this.env.SUCCESS_STATUS) {
				/**This funcion used to generating seo tag */
				this.seo.generateTags({
					title: (response.result['Site.site_title'] != undefined && response.result['Site.site_title'] != null && response.result['Site.site_title'] != '') ? response.result['Site.site_title']:this.env.SITE_TITLE,
					description: (response.result['Site.site_description'] != undefined && response.result['Site.site_description'] != null && response.result['Site.site_description'] != '') ? response.result['Site.site_description']:this.env.SITE_DESCRIPTION
				});
				/**This funcion	used to generating seo tag */
			}
		});
	}
	/**this function is used to set meta tags from text settings*/


	/**this is used to add and remove class */
	public addClass(){
		this.menuClass = !this.menuClass;
		if(this.menuClass){
			this.renderer.addClass(document.body, 'search_open');
		}else{
			this.renderer.removeClass(document.body, 'search_open');
		}
	}
	/**this is used to add and remove class */

	/**this is used to get counter */
	public getCounter(){
		this.userData = this.userService.getCurrentUser();
		if ( this.userData && Object.keys(this.userData).length !== 0 ) {
			let formData : any = { user_id : this.userService.getCurrentUser()._id };
			this.footerService.getNotificationCounter(formData).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
				if (response.status === this.env.SUCCESS_STATUS) {
					this.counter = response.counter;
				}
			});
		}
	}
	/**this is used to get counter */

	/**this is used to get notification */
	public getNotification(){
		this.isNotificationLoading = true;
		this.notificationData	= [];
		let req : any = {};
		req['data'] = {};
		req['data']['skip']  = ((this.current_page - 1)*this.limit);
		req['data']['limit'] = this.limit;
		req['data']['user_id'] = this.userService.getCurrentUser()._id;
		this.commonService.getNotifications(req).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
			if (response.status === this.env.SUCCESS_STATUS) {
				this.isNotificationLoading = false;
				this.result = response.notifications.length ? true : false;
				this.notificationData	= response.notifications;
			}
		});
	}
	/**this is used to get notification */

	/**this funvation is used to set language */
	public setLanguage(): void{
		this.commonFunctionsService.isBrowser.subscribe((isBrowser) => {
			if(isBrowser){
				const lang: any | null | undefined	=	this.commonFunctionsService.getItem('lang');
				this.translate.addLangs(this.env.LANGUAGES_ARRAY);
				const languageDirections: any	=	this.env.LANGUAGES_DIRECTIONS
				if(this.urlLang !== ''){
					const lang 		=	this.urlLang;
					this.translate.setDefaultLang(lang);
					this.translate.use(lang);
					if(languageDirections[lang] === 'ltr'){
						this.renderer.setAttribute(document.body, "dir", "ltr")
						this.renderer.removeClass(document.body, 'rtl');
					}else{
						this.renderer.setAttribute(document.body, "dir", "rtl")
						this.renderer.addClass(document.body, 'rtl');
					}
				}else{
					if (lang != undefined){
						this.translate.setDefaultLang(lang);
						this.translate.use(lang);
						if (languageDirections[lang] === 'ltr'){
							this.renderer.setAttribute(document.body, "dir", "ltr")
							this.renderer.removeClass(document.body, 'rtl');
						}else{
							this.renderer.setAttribute(document.body, "dir", "rtl")
							this.renderer.addClass(document.body, 'rtl');
						}
					}else{
						this.translate.setDefaultLang(this.env.DEFAULT_LANGUAGE);
						this.translate.use(this.env.DEFAULT_LANGUAGE);
						if (languageDirections[this.env.DEFAULT_LANGUAGE] == 'ltr'){
							this.renderer.setAttribute(document.body, "dir", "ltr")
							this.renderer.removeClass(document.body, 'rtl');
						}else{
							this.renderer.setAttribute(document.body, "dir", "rtl")
							this.renderer.addClass(document.body, 'rtl');
						}
					}
				}
			}
		});
	}
	/**this funvation is used to set language */
}
